import { useState } from 'react';

import { Window } from 'components/shared/window/window';
import { Content, TopPlace, TablePlace } from './settings-receipt.styled';
import { ReceiptTable } from './blocks/table';
import { ReceiptAdd } from './blocks/add';
import { ReceiptFind } from './blocks/find';
import { AddForm } from './blocks/forms/add-form';

export const SettingsReceipt = (props) => {
  // const dispatch = useDispatch();
  const [update, setUpdate] = useState(false);
  const [row, setRow] = useState(null);
  const [show, setShow] = useState(false);
  const [name, setName] = useState('');

  const x = window.innerWidth / 2 - 162;

  const close = () => {
    setShow(false);
    setRow(null);
  };

  const add = () => {
    setRow(null);
    setShow(true);
  };

  const refresh = () => {
    close();
    setUpdate((val) => !val);
  };

  const edit = (row) => {
    setRow(row);
    setShow(true);
  };

  const changeName = (value) => {
    setName(value);
  };

  return (
    <>
      <Window width="640px" {...props.data} defaultPosition={{ x, y: 40 }}>
        <Content>
          <TopPlace>
            <ReceiptFind onChange={changeName} value={name} />
            <ReceiptAdd addNew={add} show={show} />
          </TopPlace>
          <TablePlace>
            <ReceiptTable update={update} edit={edit} name={name} />
          </TablePlace>
        </Content>
      </Window>
      {show && <AddForm close={close} refresh={refresh} row={row} />}
    </>
  );
};
